export default __webpack_public_path__ + "static/media/LogoProgress.fbaeb502.png";